<div class="invite-button-container">
  <button class="btn btn-primary invite-button" (click)="openInviteModal(inviteModalContent)">
    +5🏵️
  </button>
</div>

<!-- Modal mời bạn bè -->
<ng-template #inviteModalContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Mời bạn bè tham gia LongLife</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="referral-code-section">
      <h5>Mã giới thiệu của bạn</h5>
      <div class="referral-code">
        <span>
          {{ userDocRef?.id ? (userDocRef.id | slice:0:6) + '...' + (userDocRef.id | slice:-4) : '' }}
        </span>
        <button class="btn btn-sm btn-outline-primary" (click)="shareReferralId()">
          Chia sẻ
        </button>
      </div>
      <p class="text-muted">Mỗi người bạn đăng ký thành công, bạn sẽ nhận được 5🏵️!</p>
    </div>
    
    <hr>
    
    <h5>Gửi lời mời qua email</h5>
    <div class="form-group">
      <input 
        type="email" 
        class="form-control" 
        id="friendEmail" 
        [(ngModel)]="friendEmail" 
        placeholder="Nhập email bạn bè"
      >
      <div class="text-danger" *ngIf="emailError">
        {{ emailError }}
      </div>
    </div>
    <div class="send-invite-button-container">
      <button 
        type="button" 
        class="btn btn-success send-invite-button" 
        [disabled]="inviteLoading"
        (click)="sendInvitation()"
      >
        <span *ngIf="inviteLoading" class="spinner-border spinner-border-sm mr-2"></span>
        Gửi lời mời
      </button>
    </div>
    
    <!-- QR Code Section -->
    <div class="qr-code-section mt-4">
      <h5>Mã QR Giới thiệu</h5>
      
      <!-- Generate QR Button -->
      <button 
        class="btn btn-info mb-3" 
        (click)="generateQRCode()"
        [disabled]="qrCodeLoading">
        <span *ngIf="qrCodeLoading" class="spinner-border spinner-border-sm me-2"></span>
        {{ qrCodeLoading ? 'Đang tạo...' : 'Tạo mã QR' }}
      </button>

      <!-- QR Code Display -->
      <div *ngIf="qrCodeDataURL" class="qr-code-container text-center">
        <img [src]="qrCodeDataURL" alt="QR Code giới thiệu" class="qr-code-image mb-3">
        
        <!-- QR Code Actions -->
        <div class="qr-actions">
          <button class="btn btn-success me-2" (click)="downloadQRCode()">
            <i class="fas fa-download"></i> Tải xuống
          </button>
          
          <button class="btn btn-primary me-2" (click)="shareQRCode()">
            <i class="fas fa-share"></i> Chia sẻ QR
          </button>
          
          <button class="btn btn-secondary" (click)="shareReferralId()">
            <i class="fas fa-link"></i> Chia sẻ Link
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
